import { CreatedUpdated } from "../../../shared/model/properties.model";
import { BaseEntity } from "../../../shared/model/app.model";
import { HREFTemplated, Self } from "../../../shared/model/link.model";
import { LogBookUser } from "ng/src/app/users/shared/user.model";

export enum OnsiteMessageSource {
    SMS = 'SMS',
    ONSITE_APP = 'ONSITE_APP'
}

export module OnsiteContact {
    export interface Model extends Omit<OnsiteContact, '_embedded' | '_links'> {}
}

export interface OnsiteContact extends CreatedUpdated, Omit<BaseEntity, 'createdBy' | 'updatedBy'> {
    contactName: string
    lastMessageSource: OnsiteMessageSource
    notificationToken: string
    phoneNumber: string
    renameMode: boolean
    _embedded: {
        createdBy: LogBookUser
        updatedBy: LogBookUser
    }
    _links: Self & {
        onsiteContacts: HREFTemplated
        updatedBy: HREFTemplated
        createdBy: HREFTemplated
    }
}